import React from 'react';
import { ChevronLeft } from 'lucide-react';

/**
 * Shared rounded-square back button used on every onboarding surface
 * (venue + host intro, wizard steps, agreement screens, pending screens).
 *
 * Visual language matches `OnboardingShell`'s inline back button and
 * `VenueSetupBackButton` so the entire onboarding funnel looks
 * consistent regardless of which shell renders it.
 *
 *   38x38 surface tile · 1px card-border · 12px radius · nested shadow
 *   ChevronLeft size 20 · strokeWidth 2 · currentColor from `--text`.
 */
export const OnboardingBackButton = React.forwardRef(function OnboardingBackButton(
  { onClick, testId = 'onboarding-back-button', ariaLabel = 'Go back', style, disabled = false },
  ref,
) {
  return (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      data-testid={testId}
      style={{
        background: 'var(--surface)',
        border: '1px solid var(--card-border)',
        borderRadius: 12,
        width: 38,
        height: 38,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: disabled ? 'not-allowed' : 'pointer',
        boxShadow: 'var(--premium-shadow-nested)',
        color: 'var(--text)',
        opacity: disabled ? 0.5 : 1,
        flexShrink: 0,
        ...style,
      }}
    >
      <ChevronLeft size={20} color="currentColor" strokeWidth={2} />
    </button>
  );
});

export default OnboardingBackButton;
